<template>
    <div>
        <div v-if="!search_result_is_empty">
            <Masonry
                    ref="masonry"
                    component="RoomCard"
                    :append_promise="append_promise"
                    @loaded="is_connecting = false"
                    @result_is_empty="search_result_is_empty = true"
                    @can_not_loading_anymore="can_not_loading_anymore = true"
            />
        </div>
        <div v-else class="result_is_empty">
            検索結果が存在しません
        </div>
    </div>
</template>
<script>
    import Masonry from '../components/Masonry'
    import Ajax from '../assets/js/Ajax'
    import Util from '../assets/js/Util'
    import { mapState } from 'vuex'

    export default {
        name: "RoomCardList",
        props: {
            search_conditions: {
                type: Array,
                default: () => []
            },
            or_search: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Masonry
        },
        data: () => ({
            append_promise: null,
            is_connecting: false,
            search_result_is_empty: false,
            can_not_loading_anymore: false,
            loaded_item_num: 0,
            loading_item_num: 30,
            timer_id: 0
        }),
        computed: {
            ...mapState('search', ["search_text"]),
            ...mapState('search', {
                vuex_search_conditions: state => state.search_conditions
            }),
        },
        created() {
            this.is_connecting = false;
            this.append();
        },
        mounted() {
            document.addEventListener('scroll', this.scrollHandler);
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.scrollHandler);
        },
        watch: {
            search_conditions() {
                this.reset();
            },
            //検索ワードの変更を検知して検索実行
            search_text() {
                clearTimeout(this.timer_id);
                this.timer_id = setTimeout(() => {
                    this.reset();

                    //トップページへ遷移（選択してる検索タグと検索ワードをURLに反映）
                    const tags = this.vuex_search_conditions.map(tag => tag.name_ja);
                    const query_param = Util.generateQueryParam('tags[]', tags, this.search_text);

                    if ( query_param ) this.$router.push('/?' + query_param);
                    else this.$router.push('/');
                }, 1000);
            }
        },
        methods: {
            append() {
                if (this.is_connecting || this.can_not_loading_anymore) return;
                this.is_connecting = true;
                const opening_flap_pages = new URLSearchParams(location.search).get('opening_flap_pages');
                this.append_promise = Ajax.pictureSearch(this.search_conditions, this.loaded_item_num, this.loading_item_num, this.or_search, this.search_text, opening_flap_pages);
                this.loaded_item_num += this.loading_item_num;
            },
            scrollHandler() {
                const scrolled_to_the_bottom = Util.checkIfUserScrolledToTheBottom();
                if ( scrolled_to_the_bottom ) this.append();
            },
            async reset() {
                this.is_connecting = false;
                this.search_result_is_empty = false;
                this.can_not_loading_anymore = false;
                this.loaded_item_num = 0;
                this.append_promise = null;
                if ( this.$refs.masonry ) await this.$refs.masonry.reset();
                this.append();
            },
        }
    }
</script>

<style scoped lang="scss">
    .result_is_empty{
        text-align: center;
        height: 90vh;
    }
</style>
